import React from 'react';
import { Star } from 'lucide-react';
export function StatsBar() {
  return <div className="bg-surface border-y border-border py-6" data-id="element-239">
      <div className="max-w-6xl mx-auto px-4" data-id="element-240">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x-0 md:divide-x divide-border" data-id="element-241">
          <div className="flex flex-col items-center justify-center" data-id="element-242">
            <span className="text-2xl md:text-4xl font-bold text-ink mb-1 font-serif" data-id="element-243">
              +3.000
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-medium" data-id="element-244">
              personas ya ordenaron su plata
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-245">
            <span className="text-2xl md:text-4xl font-bold text-ink mb-1 font-serif" data-id="element-246">
              6
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-medium" data-id="element-247">
              Tomos listos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-248">
            <span className="text-2xl md:text-4xl font-bold text-ink mb-1 font-serif" data-id="element-249">
              6
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-medium" data-id="element-250">
              Bonos incluidos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-251">
            <div className="flex items-center justify-center mb-1" data-id="element-252">
              <span className="text-2xl md:text-4xl font-bold text-ink mr-2 font-serif" data-id="element-253">
                4.9/5
              </span>
              <div className="flex" data-id="element-254">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 text-gold fill-gold" data-id="element-255" />)}
              </div>
            </div>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-medium" data-id="element-256">
              calificación
            </span>
          </div>
        </div>
      </div>
    </div>;
}